import { makeStyles } from 'tss-react/mui';
import { colors, spacing, typographySohne } from '../../styles/jss/variables';
import { HOME_HERO_BLOG_SELECTOR } from '../../utils/constants';
const useStyles = makeStyles()((theme, params, classes) => {
    var _a;
    return ({
        heading: Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: 'column' }, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm), { marginBottom: params.homeHeroBannersList ? `${spacing.medium}` : spacing.small, [theme.breakpoints.up('sm')]: {
                marginBottom: 0,
            }, [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm), { marginBottom: params.homeHeroBannersList ? `${spacing.large}` : spacing.small }), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm), '& span': {
                margin: 0,
                padding: 0,
                transform: 'unset',
            }, [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                marginBottom: spacing.medium,
                [theme.breakpoints.up('sm')]: {
                    marginBottom: '0px',
                },
                [theme.breakpoints.up('md')]: {
                    marginBottom: spacing.large,
                },
            } }),
        overlayTrustpilotWidgetClass: {
            minWidth: '240px',
            minHeight: '40px',
            padding: '9px 0px 5px 0px',
        },
        message: {
            '&': Object.assign(Object.assign(Object.assign({ color: colors.supplementary.white }, typographySohne.small_bold), theme.typographySpacing.none), { marginBottom: params.homeHeroBannersList ? spacing.xs : 'initial', [theme.breakpoints.up('sm')]: {
                    marginBottom: `${spacing.medium}  `,
                }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, typographySohne.medium_bold), { marginBottom: `${spacing.large}  ` }), [theme.breakpoints.up(1920)]: Object.assign(Object.assign({}, typographySohne.medium_bold), { marginBottom: `${spacing.xl}` }), [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                    [theme.breakpoints.up('md')]: {
                        marginBottom: spacing.medium,
                    },
                } }),
        },
        linksContainer: {
            display: params.homeHeroBannersList ? 'inline-flex  ' : 'none',
            maxWidth: '700px',
            flexDirection: 'column',
            gap: 0,
            '& .MuiButtonBase-root.MuiButton-root': {
                '& .MuiButton-label': {
                    '& span': {
                        padding: '0  ',
                    },
                },
            },
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row',
                width: '100%',
                margin: '0 auto',
                justifyContent: 'left',
                display: 'inline-flex  ',
                maxWidth: 'initial',
                gap: 0,
                '& > :not(:last-child)': {
                    marginRight: spacing.medium,
                },
            },
            [theme.breakpoints.up('md')]: {
                maxWidth: 'initial',
                width: '700px',
            },
        },
        outsideLinkContainer: {
            marginTop: spacing.small,
            marginLeft: '20px',
            marginRight: '20px',
            marginBottom: !params.showTrustpilotWidget ? spacing.medium : '0px',
            display: 'block',
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },
        link: {
            width: '100%',
            display: 'flex',
            marginBottom: spacing.small,
            '&:focus-visible': {
                outline: 0,
                outlineOffset: 0,
            },
            '&:last-child': {
                marginBottom: 0,
            },
            '&:not(:last-child)': {
                marginBottom: spacing.small,
                [theme.breakpoints.up('sm')]: {
                    marginBottom: 0,
                },
            },
            '& button': {
                flexGrow: 1,
            },
            [theme.breakpoints.up('sm')]: {
                width: '50%',
                margin: 0,
                '& button': { width: '100%' },
            },
            [theme.breakpoints.up('md')]: {
                width: '46%',
            },
            [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                [theme.breakpoints.up('sm')]: {
                    marginRight: spacing.xs,
                },
                '&:last-child': {
                    marginRight: 0,
                },
                '& button': {
                    padding: `10px ${spacing.medium} !important`, // Added to override the padding set by the Link component
                },
            },
        },
        outsideShowTrustpilotWidget: {
            minHeight: '60px',
            display: 'flex',
            marginTop: params.linksCount ? spacing.medium : spacing.small,
            marginLeft: '20px',
            marginRight: '20px',
            padding: '18px',
            justifyContent: 'center',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        content: {
            position: 'absolute',
            top: 0,
            left: 0,
            transform: 'none',
            textAlign: 'left',
            width: '100%',
            height: '100%',
            padding: `${spacing.medium}`,
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.up('sm')]: {
                width: '75%',
                padding: `${spacing.medium} 0px ${spacing.medium} ${spacing.large}`,
            },
            [theme.breakpoints.up('xl')]: {
                width: '50%',
                padding: `${spacing.large} 0px ${spacing.large} ${spacing.xl}`,
            },
            [`& .${classes.contentInner}`]: {
                margin: '0',
            },
            [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                [theme.breakpoints.up('md')]: {
                    padding: `${spacing.large} 0px ${spacing.large} ${spacing.xl}`,
                },
            },
        },
        // fills all remaining flex space, pushing date to the bottom
        contentBody: {
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
            width: '100% !important', // Added to override the width set by the Content component
        },
        contentInner: {},
        galleryLinkContainer: {
            display: params.homeHeroBannersList ? 'inline-flex' : 'none',
            [theme.breakpoints.between(0, 1120)]: {
                width: '100%',
            },
        },
        galleryLink: {
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '50%',
            },
            margin: 0,
            '& button': { width: '100%' },
            '&:not(:last-child)': {
                marginBottom: spacing.small,
                [theme.breakpoints.up('sm')]: {
                    marginRight: `${spacing.small}`,
                    marginBottom: '0',
                },
                [theme.breakpoints.up('md')]: {
                    width: '50%',
                    marginBottom: 0,
                },
                [theme.breakpoints.up(1920)]: {
                    marginRight: `${spacing.medium}`,
                },
            },
        },
        fontSohne: {
            [`& .${classes.heading}`]: Object.assign(Object.assign({}, typographySohne.xl_bold), { [theme.breakpoints.up('md')]: Object.assign({}, typographySohne.xxl_bold), [theme.breakpoints.up('xl')]: Object.assign({}, typographySohne.xxxxxl) }),
        },
        container: {
            position: 'relative',
            overflow: 'hidden',
            [theme.breakpoints.down('xl')]: Object.assign(Object.assign({ minHeight: (_a = params.height) !== null && _a !== void 0 ? _a : '336px' }, (params.height && { height: params.height })), { '@media(orientation: portrait)': {
                    placeContent: 'unset',
                } }),
            [theme.breakpoints.up('sm')]: {
                minHeight: '284px',
            },
            [theme.breakpoints.up('md')]: {
                minHeight: '360px',
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: '452px',
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: '600px',
            },
            [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                height: '376px',
                [theme.breakpoints.up('sm')]: {
                    height: '400px',
                },
                [theme.breakpoints.up('md')]: {
                    height: '500px',
                },
                [theme.breakpoints.up('lg')]: {
                    height: '600px',
                },
            },
        },
        image: {
            objectFit: 'cover',
            position: 'absolute',
            height: '100%',
            [theme.breakpoints.up('sm')]: {
                height: '100%',
            },
            '& img': {
                objectFit: 'cover',
            },
        },
        galleryContent: {
            padding: `${spacing.medium}`,
            [theme.breakpoints.up('sm')]: {
                padding: `${spacing.small} ${spacing.medium} ${spacing.small} ${spacing.xxl} !important`,
            },
            [theme.breakpoints.up('xl')]: {
                padding: `${spacing.small} ${spacing.medium} ${spacing.small} 88px !important`,
            },
        },
        mobilePositionOver: {
            [theme.breakpoints.down('sm')]: {
                [`& .${classes.image}`]: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    left: 0,
                    top: 0,
                },
            },
        },
        positionTop: {},
        // vertical alignment of contentBody items for center/bottom positions
        positionCenter: {
            [`& .${classes.contentBody}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            },
        },
        positionBottom: {
            [`& .${classes.contentBody}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
            },
            [`& .${classes.contentInner}`]: {
                [`${HOME_HERO_BLOG_SELECTOR} &`]: {
                    marginBottom: spacing.medium,
                },
            },
        },
        publishedDateAndReadTimeMessage: Object.assign({ flexShrink: 0, margin: 0, color: colors.supplementary.white }, typographySohne.small_bold),
    });
});
export default useStyles;
